/* Haolic global PDP media tabs, stock urgency and variant-aware sync.
   Uses a separate mobile gallery only for products with videos; the desktop ECX
   gallery and product forms are not replaced. */
(function () {
  'use strict';
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function getVariantId(section) {
    const mainForm = section.querySelector('form[id^="productForm-"] input[name="id"]');
    const anyForm = section.querySelector('input[name="id"]');
    return String((mainForm || anyForm || {}).value || '');
  }
  function parseScript(el) {
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  function setStock(section) {
    const box = section.querySelector('[data-haolic-stock]');
    if (!box) return;
    const inventory = parseScript(section.querySelector('[data-haolic-stock-variants]'));
    const item = inventory[getVariantId(section)];
    const threshold = Number(box.dataset.threshold || 20);
    // Shopify tracked stock, disallow-oversell policy, in-stock variant ONLY.
    // Untracked inventory/0 stock/preorder/backorder is not advertised as scarce.
    const quantity = item ? Number(item.quantity) : 0;
    const fulfillment = section.querySelector('input[name="Fulfillment Option"]:checked');
    const isPriority = !fulfillment || /in-stock/i.test(fulfillment.value);
    const show = Boolean(isPriority && item && item.management === 'shopify' && item.policy === 'deny' && item.available === true && Number.isFinite(quantity) && quantity > 0 && threshold > 0 && quantity <= threshold);
    box.hidden = !show;
    if (!show) return;
    const count = box.querySelector('[data-haolic-stock-count]');
    const bar = box.querySelector('[data-haolic-stock-bar]');
    if (count) {
      count.hidden = box.dataset.showNumber !== 'true';
      const template = box.dataset.qtyTemplate || 'Only {qty} pcs left!';
      count.textContent = template.replace(/\{qty\}/gi, String(quantity));
    }
    if (bar) {
      bar.hidden = box.dataset.showBar !== 'true';
      const fill = bar.querySelector('[data-haolic-stock-fill]');
      // This is a low-stock-threshold ratio, NOT original-stock or sales velocity.
      if (fill) fill.style.width = Math.max(0, Math.min(100, quantity / threshold * 100)) + '%';
    }
    const bottom = box.querySelector('.haolic-stock-urgency__bottom');
    if (bottom) bottom.hidden = box.dataset.showNumber !== 'true' && box.dataset.showBar !== 'true';
  }

  function pauseMedia(gallery) {
    gallery.querySelectorAll('video').forEach(v => { if (!v.paused) v.pause(); });
    gallery.querySelectorAll('iframe').forEach(frame => { const wrap = frame.closest('[data-haolic-video-wrap]'); if (wrap && wrap._haolicPoster) frame.replaceWith(wrap._haolicPoster.cloneNode(true)); else frame.remove(); });
  }
  function initGallery(section) {
    const gallery = section.querySelector('[data-haolic-mobile-media]');
    if (!gallery || gallery.dataset.haolicInitialized === 'true') return;
    gallery.dataset.haolicInitialized = 'true';
    const track = gallery.querySelector('[data-haolic-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-haolic-slide]'));
    const tabs = Array.from(gallery.querySelectorAll('[data-haolic-mode]'));
    const counter = gallery.querySelector('[data-haolic-counter]');
    const featuredMap = parseScript(gallery.querySelector('[data-haolic-variant-media]'));
    let mode = 'photo';
    let active = 0;
    let touchTimer = 0;
    const visible = () => slides.filter(slide => slide.dataset.mediaType === mode);
    function refreshCount() {
      const list = visible();
      active = Math.min(Math.max(active, 0), Math.max(0, list.length - 1));
      if (counter) counter.textContent = (list.length ? active + 1 : 0) + ' / ' + list.length;
    }
    function select(index, animate) {
      const list = visible();
      if (!list.length) return;
      active = Math.max(0, Math.min(index, list.length - 1));
      track.scrollTo({ left: list[active].offsetLeft - track.firstElementChild.offsetLeft, behavior: animate ? 'smooth' : 'auto' });
      refreshCount();
    }
    function setMode(next, animate) {
      if (mode !== next) pauseMedia(gallery);
      mode = next;
      gallery.dataset.mode = mode;
      tabs.forEach(tab => {
        const yes = tab.dataset.haolicMode === mode;
        tab.classList.toggle('is-active', yes);
        tab.setAttribute('aria-pressed', String(yes));
      });
      slides.forEach(slide => { slide.hidden = slide.dataset.mediaType !== mode; });
      active = 0;
      requestAnimationFrame(() => select(0, animate));
    }
    tabs.forEach(tab => tab.addEventListener('click', () => setMode(tab.dataset.haolicMode, false)));
    track.addEventListener('scroll', () => {
      window.clearTimeout(touchTimer);
      touchTimer = window.setTimeout(() => {
        const list = visible();
        if (!list.length || !track.clientWidth) return;
        const first = list[0].offsetLeft;
        const nearest = list.reduce((best, sl, i) => Math.abs(sl.offsetLeft - first - track.scrollLeft) < Math.abs(list[best].offsetLeft - first - track.scrollLeft) ? i : best, 0);
        if (nearest !== active) {
          active = nearest;
          pauseMedia(gallery);
        }
        refreshCount();
      }, 80);
    }, { passive: true });
    gallery.addEventListener('click', e => {
      const btn = e.target.closest('[data-haolic-play]');
      if (!btn) return;
      const wrap = btn.closest('[data-haolic-video-wrap]');
      const template = wrap && wrap.querySelector('[data-haolic-video-template]');
      if (!template || !template.content.firstElementChild) return;
      const player = template.content.firstElementChild.cloneNode(true);
      wrap._haolicPoster = btn.cloneNode(true);
      btn.replaceWith(player);
      if (player.tagName === 'VIDEO') player.play().catch(() => {});
    });
    gallery.querySelectorAll('[data-haolic-zoom]').forEach(btn => btn.addEventListener('click', () => {
      const id = btn.dataset.originalMedia;
      const originalBtn = Array.from(section.querySelectorAll('.js-product-media-open-gallery-btn')).find(b => b.dataset.dialogMediaId === id);
      if (originalBtn) originalBtn.click();
    }));
    const syncFeatured = () => {
      const id = getVariantId(section);
      const media = featuredMap[id];
      if (!media || !mobileQuery.matches) return;
      const target = slides.find(sl => String(sl.dataset.mediaId) === String(media));
      if (!target) return;
      if (target.dataset.mediaType !== mode) setMode(target.dataset.mediaType, false);
      requestAnimationFrame(() => {
        const list = visible();
        const pos = list.indexOf(target);
        if (pos >= 0) select(pos, false);
      });
    };
    section.addEventListener('change', e => {
      if (e.target.closest('.js-variant-picker') || e.target.matches('input[name="id"]')) {
        window.setTimeout(syncFeatured, 80);
        window.setTimeout(syncFeatured, 450); // theme variant refresh is asynchronous
      }
    });
    gallery.addEventListener('keydown', e => {
      if (!mobileQuery.matches || !['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      if (e.target.closest('button, video, iframe, model-viewer')) return;
      e.preventDefault(); select(active + (e.key === 'ArrowRight' ? 1 : -1), true);
    });
    const hasPhotos = slides.some(sl => sl.dataset.mediaType === 'photo');
    if (!hasPhotos) {
      const photoTab = gallery.querySelector('[data-haolic-mode="photo"]');
      if (photoTab) photoTab.hidden = true;
      setMode('video', false);
    } else setMode('photo', false);
  }

  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:currency || 'USD'}).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  // XP-2: read Shopify variant availability for the exact Color + Package + Fulfillment combination.
  function syncFulfillment(section) {
    const radioWrap = section.querySelector('ecx-variant-radios');
    if (!radioWrap) return;
    const raw = radioWrap.querySelector('[data-haolic-fulfillment-variants]');
    let variants = [];
    try { variants = JSON.parse(raw?.textContent || '[]'); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const checked = Array.from(radioWrap.querySelectorAll('input.js-variant-radio-item:checked'));
    const chosen = {};
    checked.forEach(input => { chosen[input.name] = input.value; });
    const names = Array.from(radioWrap.querySelectorAll('fieldset.product-option legend .fw-700'))
      .map(el => el.textContent.trim());
    const packageName = (chosen.Package || '').trim();
    const specialPackage = /^(XP2\+Smokeless Production|All In One)$/i.test(packageName);
    const selectedColor = String(chosen.Color || '').trim();
    const extended = specialPackage || /^(Mint|Lavender)$/i.test(selectedColor);
    section.dataset.haolicExtendedPackage = String(specialPackage);
    const prioritySelected = /in-stock/i.test(String(chosen['Fulfillment Option'] || ''));
    radioWrap.querySelectorAll('.haolic-extended-package .haolic-package-card__leadtime').forEach(el => { el.hidden = prioritySelected; });

    radioWrap.querySelectorAll('[data-haolic-preorder-leadtime]').forEach(label => {
      const copy = extended ? 'Estimated to ship in 6–7 weeks.' : 'Estimated to ship in 3–5 weeks.';
      if (label.textContent.trim() !== copy) label.textContent = copy;
    });

    const preItem = radioWrap.querySelector('.haolic-fulfillment-item:not(.haolic-priority-choice)');
    const priorityItem = radioWrap.querySelector('.haolic-priority-choice');
    const preInput = preItem?.querySelector('input.haolic-fulfillment-radio');
    const priorityInput = priorityItem?.querySelector('input.haolic-fulfillment-radio');
    if (!preInput || !priorityInput) return;

    const matchChoice = (fulfillmentValue) => variants.find(v =>
      v.options && names.every((name, idx) =>
        v.options[idx] === (name === 'Fulfillment Option' ? fulfillmentValue : chosen[name])
      )
    );
    const preVariant = matchChoice(preInput.value);
    const priorityVariant = matchChoice(priorityInput.value);
    // Shopify's variant.available already takes inventory policy into account.
    const preAvailable = Boolean(preVariant && preVariant.available);
    const priorityAvailable = Boolean(priorityVariant && priorityVariant.available);
    const hidePre = !preAvailable && priorityAvailable;
    const hidePriority = !priorityAvailable && preAvailable;

    const summary = section.querySelector('[data-haolic-fulfillment-summary]');
    if (summary) {
      const isPrioritySelected = Boolean(priorityInput.checked);
      const title = summary.querySelector('[data-haolic-fulfillment-summary-title]');
      const desc = summary.querySelector('[data-haolic-fulfillment-summary-description]');
      if (title) title.textContent = isPrioritySelected ? 'In-Stock Priority Shipping' : (extended ? 'Extended Pre-Order' : 'Standard Pre-Order');
      if (desc) desc.textContent = isPrioritySelected
        ? 'Ships in 2–4 business days. Estimated transit: 3–7 business days.'
        : (extended ? 'Estimated to ship in 6–7 weeks.' : 'Estimated to ship in 3–5 weeks.');
    }


    // Before hiding an unavailable selected radio, move to the matching purchasable variant
    // via the original theme's native variant picker so price, URL, checkout and app logic sync.
    if (priorityInput.checked && hidePriority && preAvailable) {
      priorityInput.disabled = false;
      preInput.disabled = false;
      preInput.click();
      return;
    }
    if (preInput.checked && hidePre && priorityAvailable) {
      preInput.disabled = false;
      priorityInput.disabled = false;
      priorityInput.click();
      return;
    }

    if (priorityItem) {
      priorityItem.hidden = hidePriority;
      priorityItem.classList.toggle('haolic-priority-disabled', !priorityAvailable);
      priorityInput.disabled = hidePriority && !priorityInput.checked;
      priorityInput.setAttribute('aria-disabled', String(!priorityAvailable));
    }
    if (preItem) {
      preItem.hidden = hidePre;
      preInput.disabled = hidePre && !preInput.checked;
      preInput.setAttribute('aria-disabled', String(!preAvailable));
    }

    let status = radioWrap.querySelector('[data-haolic-fulfillment-availability]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'haolic-fulfillment-availability';
      status.setAttribute('data-haolic-fulfillment-availability', '');
      status.setAttribute('role', 'status');
      radioWrap.querySelector('[data-haolic-fulfillment-options]')?.after(status);
    }
    // Status text only when neither variant is purchasable. The selected summary
    // already explains the shipping time, so avoid duplicated out-of-stock prose.
    if (status) {
      const soldOut = !preAvailable && !priorityAvailable;
      status.hidden = !soldOut;
      status.textContent = soldOut ? 'This color and package combination is currently unavailable.' : '';
    }
    const fulfillmentList = radioWrap.querySelector('[data-haolic-fulfillment-options]');
    if (fulfillmentList) {
      const visibleCount = [preItem, priorityItem].filter(item => item && !item.hidden).length;
      fulfillmentList.classList.toggle('haolic-fulfillment-list--single', visibleCount === 1);
    }

    // Retain package-card price sync that previously worked in V5.
    const pIndex = names.indexOf('Package');
    if (pIndex >= 0) {
      const currency = section.dataset.haolicCurrency || window.Shopify?.currency?.active || 'USD';
      radioWrap.querySelectorAll('.haolic-package-item').forEach(item => {
        const input = item.querySelector('input.haolic-package-radio');
        const match = variants.find(v => v.options?.every((val, idx) =>
          idx === pIndex ? val === input?.value : val === chosen[names[idx]]
        ));
        const price = item.querySelector('.haolic-package-card__price');
        const compare = item.querySelector('.haolic-package-card__compare');
        if (!match || !price) return;
        price.textContent = money(match.price, currency);
        if (compare) {
          compare.textContent = match.compare_at_price > match.price ? money(match.compare_at_price, currency) : '';
          compare.hidden = !(match.compare_at_price > match.price);
        }
      });
    }
  }

  function init(section) {
    if (!section || !section.classList.contains('main-product')) return;
    initGallery(section);
    setStock(section);
    syncFulfillment(section);
    if (section.dataset.haolicStockBound === 'true') return;
    section.dataset.haolicStockBound = 'true';
    // Preserve native variant selection when switching packages.
    // Avoid selecting priority while an extended-lead package is active.
    section.addEventListener('click', function(e) {
      const choice = e.target.closest('.haolic-priority-choice .haolic-fulfillment-card');
      if (choice && choice.closest('.haolic-priority-disabled')) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    const onUpdate = (e) => {
      if (e.target.closest('.js-variant-picker') || e.target.matches('input[name="id"]')) {
        window.setTimeout(() => { setStock(section); syncFulfillment(section); }, 100);
        window.setTimeout(() => { setStock(section); syncFulfillment(section); }, 500);
      }
    };
    section.addEventListener('change', onUpdate);
    const inventoryNode = section.querySelector('.js-inventory-tracking');
    if (inventoryNode) new MutationObserver(() => { setStock(section); syncFulfillment(section); }).observe(inventoryNode, { childList: true, subtree: true, characterData: true });
  }
  // Global delegated package-image preview. This also survives Shopify variant rerenders.
  document.addEventListener('click', function(e) {
    const opener = e.target.closest('[data-haolic-package-preview]');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      const section = opener.closest('.main-product');
      const dlg = section && section.querySelector('[data-haolic-package-dialog]');
      const src = opener.dataset.previewSrc;
      if (!dlg || !src) return;
      const img = dlg.querySelector('.haolic-package-preview-dialog__image');
      const caption = dlg.querySelector('.haolic-package-preview-dialog__caption');
      img.src = src;
      img.alt = opener.dataset.previewAlt || 'Package image';
      caption.textContent = opener.dataset.previewAlt || '';
      dlg._haolicOpener = opener;
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open','');
      return;
    }
    const closeBtn = e.target.closest('[data-haolic-package-close]');
    const clickedDialog = e.target.matches('[data-haolic-package-dialog]') ? e.target : null;
    const dlg = (closeBtn && closeBtn.closest('[data-haolic-package-dialog]')) || clickedDialog;
    if (dlg) {
      e.preventDefault();
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }
  }, true); // capture phase: preview clicks cannot bubble into theme's variant picker
  document.addEventListener('close', function(e) {
    if (!e.target.matches('[data-haolic-package-dialog]')) return;
    const opener = e.target._haolicOpener;
    if (opener && opener.isConnected) opener.focus({preventScroll:true});
  }, true);
  function start() { document.querySelectorAll('.main-product').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.main-product').forEach(init));
})();
